import type { FieldError, FieldValues, Path, UseFormRegister } from 'react-hook-form'

import { cn } from 'src/shared/utils/cn'

import BusinessFormErrorMessage from './business-form-error-message'

interface BusinessFormFieldProps<T extends FieldValues> {
  register: UseFormRegister<T>
  name: Path<T>
  placeholder: string
  type: string
  error?: FieldError
  autoFocus?: boolean
}

export default function BusinessFormField<T extends FieldValues>({
  register,
  name,
  placeholder,
  type,
  error,
  autoFocus = false,
}: BusinessFormFieldProps<T>) {
  return (
    <div className="relative flex w-full flex-col items-center justify-center">
      <input
        {...register(name)}
        type={type || 'text'}
        placeholder={placeholder}
        autoComplete="off"
        autoFocus={autoFocus}
        className={cn(
          'w-full flex-1 items-center rounded-full p-[10px] text-center text-[42px] font-bold tracking-[-0.78px] text-primary placeholder:text-[#D8D8D6] focus-visible:outline-none md:text-[52px]',
        )}
      />
      {error && (
        <div className="absolute bottom-[-20px]">
          <BusinessFormErrorMessage error={error} />
        </div>
      )}
    </div>
  )
}
